<template>
  <div>
    <div style="border: thin solid rgba(0,0,0,.12)" class="mt-4">
      <v-toolbar elevation="0">
        <v-text-field
            flat
            solo
            clearable
            prepend-icon="search"
            placeholder="Type something"
            v-model="opsitable.search"
            hide-details
            class=""
        ></v-text-field>
        <v-btn small elevation="0" class="ml-2" color="primary" @click.native="refreshdata()">
          <v-icon dark>refresh</v-icon>Refresh
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
          :headers="headers"
          :search="opsitable.search"
          :items="adminuser"
          class="elevation-0"
          item-key="memberid"
          :options.sync="opsitable"
          :server-items-length="totaladminuser"
          :loading="loading"
          @update:options="refreshdata">
        <template v-slot:item.createat="{ item }">
          {{formatDate(item.updateat)}}
        </template>
        <template v-slot:item.updateat="{ item }">
          {{formatDate(item.updateat)}}
        </template>
        <template v-slot:item.memberstatus="{ item }">
          <div class="ma-4 text-xs-left">
            <v-chip
                :color="colorStatus(item.memberstatus)"
                small
                text-color="white">
              {{ statusText(item.memberstatus) }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.confm="{ item }">
          <div class="ma-4 text-xs-left">
            <v-chip
                :color="colorStatus(item.confm)"
                small
                text-color="white">
              {{ statusconfm(item.confm) }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.aksi="{ item }">
          <v-btn x-small dark fab text @click.native="opendetail(item)" class="blue ml-2">
            <v-icon small>list</v-icon>
          </v-btn>
          <v-btn x-small dark fab text @click.native="blocuser(item)" class="red ml-2">
            <v-icon small>delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
import moment from 'moment'

export default {
  name: 'AllUser',
  data: () => ({
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      paymentstatus: '',
      sortBy: ['memberid']
    },
    headers: [
      {
        text: 'Id',
        value: 'memberid'
      },
      {
        text: 'Nama',
        value: 'membername'
      },
      {
        text: 'Email',
        value: 'memberemail'
      },
      {
        text: 'Akif',
        value: 'memberstatus'
      },
      {
        text: 'CreateAt',
        value: 'createat'
      },
      {
        text: 'UpdateAt',
        value: 'updateat'
      },
      {
        text: 'Aksi',
        value: 'aksi'
      }

    ]
  }),
  mounted () {
  },
  computed: {
    ...mapState('AdminUserStore', ['adminuser', 'loading', 'userdetail', 'totaladminuser', 'totalsellerreq', 'sellerreq', 'sumuser'])
  },
  methods: {
    ...mapActions('AdminUserStore', ['getUserDetail', 'getAllUsers', 'setdialoguserdetail', 'getRoles', 'getSumUser']),
    colorStatus (val) {
      if (parseInt(val) > 0) {
        return 'green'
      } else {
        return 'red'
      }
    },
    statusText (val) {
      if (parseInt(val) > 0) {
        return 'Aktif'
      } else {
        return 'Non Aktif'
      }
    },
    statusconfm (val) {
      if (parseInt(val) === 1) {
        return 'Ya'
      } else {
        return 'Belum'
      }
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    blocuser (item) {

    },
    opendetail (item) {
      this.getUserDetail(item.memberid)
      this.getRoles()
      this.setdialoguserdetail(true)
    },
    refreshdata () {
      this.getAllUsers(this.opsitable)
    }
  }
}
</script>

<style scoped>

</style>
